import { render, staticRenderFns } from "./nav-section-item.vue?vue&type=template&id=52a06fec&"
import script from "./nav-section-item.vue?vue&type=script&lang=js&"
export * from "./nav-section-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports